import { defineMessages } from 'react-intl'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'

const messages = defineMessages({
  short: {
    id: 'ExerciseWrapper.description.short',
    defaultMessage:
      'Learn how to do {exerciseName} with step-by-step instructions, video demonstrations, and details on the muscles worked. Perfect for the gym.'
  },
  shortBodyweight: {
    id: 'ExerciseWrapper.description.short.bodyweight',
    defaultMessage:
      'Learn how to do {exerciseName} with step-by-step instructions, video demonstrations, and details on the muscles worked. Perfect for the gym or at home.'
  },
  long: {
    id: 'ExerciseWrapper.description.long',
    defaultMessage:
      'How to do {exerciseName} with video instructions and muscles worked explained. Suitable for the gym.'
  },
  longBodyweight: {
    id: 'ExerciseWrapper.description.long.bodyweight',
    defaultMessage:
      'How to do {exerciseName} with video instructions and muscles worked explained. Suitable for the gym or at home.'
  }
})

const MAX_SHORT_DESCRIPTION_LENGTH = 25

/**
 * @param props
 * @param props.exerciseName
 * @param props.intl
 * @param props.isBodyweight
 * @return {string}
 */
export function getDescriptionExerciseUtil (props) {
  const exerciseName = props.exerciseName || ''
  const {
    intl,
    isBodyweight
  } = props

  let message
  if (exerciseName.length <= MAX_SHORT_DESCRIPTION_LENGTH) {
    message = isBodyweight ? messages.shortBodyweight : messages.short
  } else {
    message = isBodyweight ? messages.longBodyweight : messages.long
  }

  return formatMessageIntlUtil(intl, message, { exerciseName })
}
